import React, { useEffect, useRef, useState } from 'react'
import { QuestionImage } from './QuestionImage';

const answers = ['A', 'B', 'C', 'D', 'E'];



const Question = ({ data, number, onAnswered, selectedAnswer, result }) => {

   

    const parseBook = book => {
        switch (book) {
            case 'CIENCIAS_DA_NATUREZA': return 'Ciências da natureza e suas tecnologias';
            case 'LINGUAGENS': return 'Liguagens e códigos';
            case 'MATEMATICA': return 'Matemática e suas tecnologias';
            case 'CIENCIAS_HUMANAS': return 'Ciências humanas e suas tecnologias';
            default: return ''
        }
    };

    const parseResultClassName = answer => {
        if (answer === data.gabarito) {
            return 'correct'
        } else if (answer === data.resposta) {
            return 'wrong'
        }

        return ''
    };

    // useEffect(() => {
    //     console.log(ref)
    //     handleImageLoaded();
    // }, [])

    // useEffect(() => {
    //     console.log('estado:', loading)
    // }, [loading])

    return (
        <div className="question">
            <h5 className="primary">{parseBook(data.caderno)}</h5>
            <strong>Questão {('00' + number).slice(-2)}</strong><br />
            <small className="font-italic">Enem, {data.ano}</small>
            <div className="question__image"> 
                <QuestionImage dataUrl={data.url} />
                {/* <img decoding='async' ref={ref} onLoad={onLoad} src={data.url} alt="" /> */}
            </div>
            <p className="text-center">{result ? '' : 'SELECIONE UMA RESPOSTA:'}</p>
            <ul className="question__answers">
                {
                    answers.map(answer => {
                        return (
                            <li
                                className={`question__answer ${result ?
                                    parseResultClassName(answer)
                                    : selectedAnswer === answer ? 'selected' : ''}`
                                }
                                key={answer}
                            >
                                <button
                                    type="button"
                                    className="question__answer__button"
                                    onClick={() => !result && onAnswered(answer)}
                                >
                                    {answer}
                                </button>
                            </li>
                        )
                    })
                }
            </ul>
        </div>
    )
};

export { Question }
